// Toggle Agreements dropup in LexiQamus site footer (mirrors lab.lexiqamus.com main.js).
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['agreementsDropup']

  // Opens the clicked dropup; closes any other open dropup first (only one open at a time).
  toggleDropup(event) {
    event.preventDefault()
    event.stopPropagation()

    const clickedAgreementsDropup = event.currentTarget
    const isActive = clickedAgreementsDropup.classList.contains('active')

    this.agreementsDropupTargets.forEach((element) => element.classList.remove('active'))

    if (!isActive) {
      clickedAgreementsDropup.classList.add('active')
    }
  }

  // Closes all dropups when the user clicks outside a .dropupCustom element.
  closeOnOutsideClick(event) {
    if (event.target.closest('.dropupCustom')) {
      return
    }

    this.agreementsDropupTargets.forEach((element) => element.classList.remove('active'))
  }
}
